<template>
    <div>
        <div v-if="!this.app.WholeSaler.isWholeSaler || app.auth.isLogged" class="d-flex">
            <div class="ms-auto">
                <span class="d-none d-md-block unex-button" @click="app.routerPush('myConfigs')">
                    {{ $t('nav_titel_my_configs') }}
                </span>
            </div>
        </div>
        <div v-if="isStageActive(2)" class="d-none d-md-flex steps-container mt-4">
            <div @click="pressedScreen('1')"
                class="step" :class="{ 'step-on': isStageActive(1) }">
                <div class="step-name">{{ $t('nav_v2_titel_s1') }}</div>
                <div class="step-marker">
                <div class="circle"></div>
                <div class="line" :class="{ 'step-on': isStageActive(2) }"></div>
                </div>
            </div>
            <div @click="pressedScreen('2')"
                class="step" :class="{ 'step-on': isStageActive(2) }">
                <div class="step-name">{{ $t('nav_v2_titel_s2') }}</div>
                <div class="step-marker">
                <div class="circle"></div>
                <div class="line" :class="{ 'step-on': isStageActive(3) }"></div>
                </div>
            </div>
            <div v-if="screen3Available" @click="pressedScreen('3')"
                class="step" :class="{ 'step-on': isStageActive(3) }">
                <div class="step-name">{{ $t('nav_v2_titel_s3') }}</div>
                <div class="step-marker">
                <div class="circle"></div>
                <div class="line" :class="{ 'step-on': isStageActive(4) }"></div>
                </div>
            </div>
            <div @click="pressedScreen('4')"
                class="step" :class="{ 'step-on': isStageActive(4) }">
                <div class="step-name">{{ $t('nav_v2_titel_s4') }}</div>
                <div class="step-marker">
                <div class="circle"></div>
                </div>
            </div>
        </div>
        <!-- <div class="ms-auto">
            <span class="d-none d-md-block unex-button" @click="app.routerPush('myConfigs')">
                {{ $t('nav_titel_my_configs') }}
            </span>
        </div> -->
    </div>
</template>

<style scoped lang="scss">

.steps-container {
  display: flex;
  justify-content: space-between;
  width: 75%;
  margin: auto;
}

.step {
  flex: 1;
  text-align: center;
  position: relative;
  cursor: pointer;
}

.step-name {
  margin-bottom: 8px;
  font-size: 14px;
}

.step-marker {
  position: relative;
  height: 20px;
}

.circle {
  width: 12px;
  height: 12px;
  background-color: #333;
  border-radius: 50%;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.line {
  position: absolute;
  top: 5px;
  left: 50%;
  width: 100%;
  height: 2px;
  background-color: #ccc;
  transform: translateX(6px);
  z-index: 1;
}

/* El último paso no necesita línea */
.step:last-child .line {
  display: none;
}

.step-on {
  color: #DE271F;
}

.step-on {
  color: #DE271F;
}

.step-on .circle {
  background-color: #DE271F;
}
.line.step-on  {
  background-color: #DE271F;
}
</style>



<script>
import { app } from "../application.js";

export default {
    name: "navigationbarV2Component",
    props: ["infoNavigationbar"],
    data() {
        return {
            app,
            icon_on: require("@/assets/images/navigationbar/On.png"),
            icon_off: require("@/assets/images/navigationbar/Off.png")
        };
    },

    computed: {
        screen3Available() {
            // si no estamos en P4, mostramos link a P2
            // si estamos en P4, no tenemos commonMainElementParameters ni mainElementParameters, ocultamos link a P2
            if (this.app.currentConfiguration.stage != 4) {
                return true;
            }
            if (Object.keys(this.app.currentConfiguration.commonMainElementParameters).length > 0) {
                return true;
            }
            const mainParamsKeys = Object.keys(this.app.currentConfiguration.mainElementParameters);
            if (mainParamsKeys.length == 1) {
                const mainParamsKey = mainParamsKeys[0];
                const mainParams = this.app.currentConfiguration.mainElementParameters[mainParamsKey];
                if (Object.keys(mainParams).length > 0) {
                    return true;
                }
            }
            return false;
        }
    },

    methods: {
        pressedScreen: function(screen) {

            //is stage is not myConfigs navigate normally
            if (screen === "1") {
                app.navigateToStageAsync("1");

            } else if (screen === "2" && this.app.currentConfiguration.configurator && this.app.currentConfiguration.configurator.id) {
            //} else if (screen === "2" ) {

                app.navigateToStageAsync("2");

            } else if (screen === "3") {

                app.currentConfiguration.stage > 3 ? this.app.navigateToStageAsync("3") : "";

            } else if (screen === "4") {

                app.currentConfiguration.stage === 4
                    ? app.navigateToStageAsync("4")
                    : "";

            } else if (screen === "myConfigs") {
                this.app.routerPush("myConfigs");

                // //si no esta logejat portal directament a logejarse
                // if(this.app.auth.isLogged){

                // //si ja està logejat portal a la pagina de mis configuraciones
                // }else{
                //     this.app.auth.login();

                // }
            }
        },

        saveCurrentConfig: function() {
            let self = this;

            //Here the message could be stored in the app depending on the language
            let infoModal = {
                modalToShow: "saveCurrentConfig",
                title: "Guarda la configuración actual",
                html_message: `
                    <div class="form-group row mt-0 mb-2 mr-3 ml-3 d-flex flex-row align-items-center">

                        <div class="d-block text-left mb-3">
                            <h5>Indica con qué nombre quieres guardar esta configuración:</h5>
                        </div>

                        <label for="inputName" class="col-2">Nombre:</label>
                        <div class="col-10">
                            <input type="text" class="form-control" id="inputName" />
                        </div>
                    </div>
                `,
                message: "",
                showConfirmationButton: true,
                showCancelButton: true,
                textConfirmationButton: "Si",
                textCancelButton: "No"
            };

            //ES6 destructuring object resolved from promise:
            self.app
                .showModal(infoModal)
                .then(({ userAction, paramResult }) => {
                    if (userAction === "modal_rejected") {
                        //do nothing
                    } else if (userAction === "modal_confirmed") {

                    }
                });
        },

        showAccesDeniedOrRedirectToUserConfigs: function() {
            if (this.app.auth.isLogged) {
                app.showMyConfigs();
            } else {
                let self = this;
                let infoModal = {
                    modalToShow: "showAccesDenied",
                    title: "Login",
                    html_message: "",
                    message: "Logeate para acceder a tus configuraciones.",
                    showConfirmationButton: false,
                    showCancelButton: true,
                    textConfirmationButton: "Si",
                    textCancelButton: "No"
                };

                self.app
                    .showModal(infoModal)
                    .then(({ userAction, paramResult }) => {
                        if (userAction === "modal_rejected") {
                            //do nothing
                        } else if (userAction === "modal_confirmed") {
                        }
                    });
            }
        },

        isStageActive(stage) {
            return this.app.currentConfiguration.stage >= stage && !this.app.userIsInsideMyConfigs;
        }
    },
    components: {}
};
</script>
